import React, { useState, useEffect } from 'react';
import SimpleCheckBox from '../../../components/checkbox/check';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Api from 'src/services/api';
import * as componentActions from '../.././../redux/actions/configs';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';

import { Typography, Divider, Paper, Box, Tooltip } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import StatusManager from './statusmanager';
import { PapiroConsole } from 'src/utils/papiroConsole';
import * as ConfigCalledsStatusList from '../../../services/configcalledsstatuslist.service'
import * as StatusList from '../../../services/status.service'
import SimpleAutoComplete from "../../../components/auto-complete/autocomplete";
import Switch from '@mui/material/Switch';

const ConfigCalleds = (props) => {
  const [enableTagsOnCalleds, setEnableTagsOnCalleds] = useState(props.initialValueEnableTagsOnCalleds ? props.initialValueEnableTagsOnCalleds : false);
  const [enableAutomaticCalledTagging, setEnableAutomaticCalledTagging] = useState(props.initialValueEnableAutomaticCalledTagging ? props.initialValueEnableAutomaticCalledTagging : false);
  const [statusesData, setStatusesData] = useState({
    allStatuses: [],
    changedStatuses: []
  });
  const [applyInternalExpirationValidation, setApplyInternalExpirationValidation] = useState(props.initialValueApplyInternalExpirationValidation ? props.initialValueApplyInternalExpirationValidation : false);
  const [initialStatuses, setInitialStatuses] = useState(null);
  const [loadingStatuses, setLoadingStatuses] = useState(true);
  const [defaultReopenStatus, setDefaultReopenStatus] = useState({ id: 0, name: '' });
  const [defaultReopenStatusList, setDefaultReopenStatusList] = useState([]);
  const [enableRequesterOnPortalCalleds, setEnableRequesterOnPortalCalleds] = useState(props.initialValueEnableRequesterOnPortalCalleds ? props.initialValueEnableRequesterOnPortalCalleds : false);
  PapiroConsole.log("defaultreopenstatus")
  PapiroConsole.log(defaultReopenStatus)

  // Carregar os status iniciais ao montar o componente
  useEffect(() => {
    const fetchStatusesData = async () => {
      try {

        props.setLoading(true)
        // Buscar os status da API
        await GetAllConfigStatus()
        await GetAllReopenStatus()

      } catch (error) {
        props.setLoading(false)

      } finally {
        props.setLoading(false)
        setLoadingStatuses(false);
      }
    };

    fetchStatusesData();
  }, []);



  const GetAllConfigStatus = async () => {

    var result = await ConfigCalledsStatusList.GetAllConfigStatus()
    if (result.success) {
      if (result.data) {
        setInitialStatuses(result.data);

        PapiroConsole.log("props.initialValueDefaultReopenStatus")
        PapiroConsole.log(props.initialValueDefaultReopenStatus)

      }

    } else {
      const intl = this.props.intl;
      props.setMessage(true, 'error', result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" }));
      Api.kickoff(result);
    }
  }

  const GetAllReopenStatus = async () => {

    var result = await StatusList.ReopenStatus()
    if (result.success) {
      if (result.data) {
        setDefaultReopenStatusList(result.data);

        if (props.initialValueDefaultReopenStatus && result.data && result.data.length > 0) {

          const initialValueDefaultReopenStatus = result.data.find(item => item.id === props.initialValueDefaultReopenStatus);
          PapiroConsole.log(initialValueDefaultReopenStatus)
          if (initialValueDefaultReopenStatus) {
            setDefaultReopenStatus(initialValueDefaultReopenStatus)
          }

        }
      }

    } else {
      const intl = this.props.intl;
      props.setMessage(true, 'error', result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" }));
      Api.kickoff(result);
    }
  }

  // Função para lidar com as mudanças no componente StatusManager
  const handleStatusChange = (data) => {
    setStatusesData(data);
  };

  const fetchStatusesFromApi = async () => {
    try {
      // Simulando um delay de rede
      await new Promise((resolve) => setTimeout(resolve, 800))

      // Dados mockados que seriam retornados pela API
      return [
        {
          id: 1,
          name: "Aberto",
          active: true,
          description: "Chamados recém-criados que ainda não foram atendidos",
          color: "#4CAF50",
        },
        {
          id: 2,
          name: "Em andamento",
          active: true,
          description: "Chamados que estão sendo atendidos pela equipe de suporte",
          color: "#2196F3",
        },
        {
          id: 3,
          name: "Aguardando cliente",
          active: true,
          description: "Chamados que necessitam de informações adicionais do cliente",
          color: "#FF9800",
        },
        {
          id: 4,
          name: "Aguardando terceiros",
          active: false,
          description: "Chamados que dependem de fornecedores ou parceiros externos",
          color: "#9C27B0",
        },
        {
          id: 5,
          name: "Resolvido",
          active: true,
          description: "Chamados que foram solucionados e aguardam confirmação do cliente",
          color: "#009688",
        },
        {
          id: 6,
          name: "Fechado",
          active: true,
          description: "Chamados que foram solucionados e confirmados pelo cliente",
          color: "#607D8B",
        },
        {
          id: 7,
          name: "Cancelado",
          active: false,
          description: "Chamados que foram cancelados pelo cliente ou pela equipe",
          color: "#F44336",
        },
        {
          id: 8,
          name: "Reaberto",
          active: false,
          description: "Chamados que foram reabertos após terem sido fechados",
          color: "#E91E63",
        },
      ]
    } catch (error) {
      console.error("Erro ao buscar status da API:", error)
      throw new Error("Não foi possível carregar os status. Por favor, tente novamente mais tarde.")
    }
  }

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const intl = props.intl;

  //   props.setLoading(true);

  //   try {
  //     // Primeiro, salvar as configurações gerais
  //     let configData = {
  //       enableTagsOnCalleds: enableTagsOnCalleds,
  //       EnableAutomaticCalledTagging: enableAutomaticCalledTagging,
  //       configId: props.configId
  //     };

  //     const configResult = await Api.put('/configcalleds', configData);

  //     // Se houver status alterados, salvá-los também
  //     if (statusesData.changedStatuses && statusesData.changedStatuses.length > 0) {
  //       // Preparar os dados para enviar ao backend
  //       const statusesToUpdate = statusesData.changedStatuses.map((status) => ({
  //         id: status.id,
  //         active: status.active,
  //       }));

  //       // Enviar apenas os status alterados para a API
  //       await Api.post('/configcalledstatuses', { selectedStatusIds: statusesToUpdate.filter(s => s.active).map(s => s.id) });
  //     }

  //     // Se chegou até aqui, tudo foi salvo com sucesso
  //     props.setLoading(false);
  //     props.setMessage(true, 'success', 'Configurações atualizadas com sucesso');
  //     props.updatedConfigCalleds(enableTagsOnCalleds, enableAutomaticCalledTagging);
  //   } catch (err) {
  //     props.setLoading(false);
  //     if (err.response && err.response.data && err.response.data.errors) {
  //       props.setMessage(true, 'error', err.response.data.errors[0]);
  //     } else {
  //       props.setMessage(true, 'error', intl.formatMessage({ id: "process.error" }));
  //     }
  //     console.error("Erro ao salvar configurações:", err);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const intl = props.intl;

    props.setLoading(true)

    let data = {
      enableTagsOnCalleds: enableTagsOnCalleds,
      EnableAutomaticCalledTagging: enableAutomaticCalledTagging,
      ApplyInternalExpirationValidation: applyInternalExpirationValidation,
      EnableRequesterOnPortalCalleds: enableRequesterOnPortalCalleds ? 1 : 0,
      configId: props.configId,
      defaultReopenStatus: defaultReopenStatus ? defaultReopenStatus.id : null

    };

    if (statusesData.changedStatuses && statusesData.changedStatuses.length > 0) {
      // Preparar os dados para enviar ao backend
      const statusesToUpdate = statusesData.changedStatuses.map((status) => ({
        id: status.id,
        visibleincalledediting: status.visibleincalledediting,
        visibleincalledlistfilter: status.visibleincalledlistfilter,
        configcalledsstatuslistid: status.configcalledsstatuslistid

      }));


      data.StatusesToUpdate = statusesToUpdate
      PapiroConsole.log("statusesToUpdate")
      PapiroConsole.log(statusesToUpdate)

    }



    Api.put('/configcalleds', data)
      .then((result) => {
        if (result.data.success) {
          props.setLoading(false)
          props.setMessage(true, 'success', 'Registro atualizado com sucesso')
          props.updatedConfigCalleds(enableTagsOnCalleds, enableAutomaticCalledTagging, applyInternalExpirationValidation)
        } else {

          props.setLoading(false)
          props.setMessage(true, 'error', result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))


        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          props.setLoading(false)
          props.setMessage(true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))
        }
        else {
          props.setLoading(false)
          props.setMessage(true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }) + err.response.data)
        }
      });

  }

  const handleChangeSwitch = (e) => {
    const { name, checked } = e.target;

    if (name === 'enableRequesterOnPortalCalleds') {
      setEnableRequesterOnPortalCalleds(checked);
    }
  }

  return (
    <div>
      <Paper elevation={0} sx={{ p: 3, mb: 4 }}>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <SimpleCheckBox
              label={props.intl.formatMessage({ id: 'enable.tags.on.calleds' })}
              name='enableTagsOnCalleds'
              stateName='enableTagsOnCalleds'
              changeSelect={(stateName, value) => {
                setEnableTagsOnCalleds(value)
                props.handleCheckboxChange(stateName, value)
              }}
              selected={enableTagsOnCalleds}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <SimpleCheckBox
              label={props.intl.formatMessage({ id: "enable.automatic.called.tagging" })}
              name='enableAutomaticCalledTagging'
              stateName='enableAutomaticCalledTagging'
              changeSelect={(stateName, value) => setEnableAutomaticCalledTagging(value)}
              selected={enableAutomaticCalledTagging}
            />
          </Grid>
          <Grid item xs={8}>
            <SimpleCheckBox
              label={props.intl.formatMessage({ id: "apply.internal.expiration.validation" })}
              name='applyInternalExpirationValidation'
              stateName='applyInternalExpirationValidation'
              changeSelect={(stateName, value) => {
                setApplyInternalExpirationValidation(value)
                props.handleCheckboxChange(stateName, value)
              }}
              selected={applyInternalExpirationValidation}
            />
          </Grid>

          <Grid item xs={0.5}
          style={{ textAlign: "middle", alignSelf: "stretch", marginTop: '8px' }}>
            <Tooltip style={{ cursor: 'pointer' }} title={props.intl.formatMessage({ id: 'apply.internal.expiration.validation.tooltip' })}>
              <HelpIcon />
            </Tooltip>
          </Grid>

          <Grid item xs={8}>
            <Typography component="div" variant="body1" gutterBottom>
              {props.intl.formatMessage({ id: "enable.requester.portal.calleds" })}
            </Typography>
            <Switch
              checked={enableRequesterOnPortalCalleds}
              onChange={handleChangeSwitch}
              name="enableRequesterOnPortalCalleds"
              inputProps={{ 'aria-label': 'enable requester on portal calleds' }}
            />
          </Grid>



          <Grid item xs={12} sm={12}>
            <SimpleAutoComplete
              label="Status padrão de reabertura"
              name="defaultreopenstatus"
              options={defaultReopenStatusList}
              stateName="defaultreopenstatus"
              changeSelect={(stateName, value) => setDefaultReopenStatus(value)}
              selected={defaultReopenStatus}

            />
          </Grid>
        </Grid>
      </Paper>

      <Divider sx={{ my: 4 }} />

      {/* Componente de Status Manager */}
      {!loadingStatuses && (
        <StatusManager initialStatuses={initialStatuses} onChange={handleStatusChange} />
      )}

      {/* Informação sobre status alterados */}
      {/* {statusesData.changedStatuses && statusesData.changedStatuses.length > 0 && (
        <Paper elevation={0} sx={{ p: 3, my: 2, backgroundColor: "#fff8e1", borderLeft: "4px solid #ffc107" }}>
          <Typography variant="subtitle1" gutterBottom>
            {props.intl.formatMessage({ id: 'status.changed' })}: {statusesData.changedStatuses.length}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {props.intl.formatMessage({ id: 'status.changed.description' })}
          </Typography>
        </Paper>
      )} */}

      <Grid container style={{ marginTop: '25px' }}>
        <Grid item xs={4} />
        <Grid item xs={4} />
        <Grid item xs={4} container alignItems="flex-end" justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            onClick={handleSubmit}

          >
            {props.intl.formatMessage({ id: 'save' })}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  configs: state.configs,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ConfigCalleds))
